export default __webpack_public_path__ + "static/media/4.d9735317.svg";